export default __webpack_public_path__ + "static/media/__share__icon__leftmenubar.812295ff.svg";